import { Outlet, useLocation } from "react-router-dom";

/**
 * PageTransition (CSS keyframes + key-based remount).
 *
 * `key={pathname}` forza React a smontare il vecchio nodo e a montare un
 * nodo DOM completamente nuovo: la CSS animation (keyframe) viene applicata
 * dal primo paint e parte sempre, senza dipendere da state toggle / rAF / etc.
 */
export default function PageTransition({ variant = "soft" }) {
  const location = useLocation();
  const animClass = variant === "tight" ? "page-anim-tight" : "page-anim-soft";

  return (
    <div
      key={location.pathname}
      className={animClass}
      data-testid={`page-transition-${variant}`}
    >
      <Outlet />
    </div>
  );
}
